import { FormGroup, InputLabel, Stack } from '@mui/material';
import CustomAutocompleteSearch from 'common/components/CustomAutocompleteSearch';
import { useTranslation } from 'react-i18next';
import SettingsKey from '../utils/settingsTypes';

const TIME_ZONES = [
    {
        timezone: 'Europe/Madrid',
    },
    {
        timezone: 'America/Mexico_City',
    },
    {
        timezone: 'Europe/London',
    },
    {
        timezone: 'Europe/Warsaw',
    },
    {
        timezone: 'Europe/Vienna',
    },
    {
        timezone: 'Europe/Paris',
    },
    {
        timezone: 'Europe/Dublin',
    },
    {
        timezone: 'Europe/Belgrade',
    },
    {
        timezone: 'Mexico/General',
    },
    {
        timezone: 'Europe/Berlin',
    },
    {
        timezone: 'Europe/Stockholm',
    },
    {
        timezone: 'Europe/Brussels',
    },
    {
        timezone: 'America/Guayaquil',
    },
    {
        timezone: 'Europe/Bucharest',
    },
    {
        timezone: 'Europe/Rome',
    },
    {
        timezone: 'Europe/Tirane',
    },
    {
        timezone: 'Europe/Skopje',
    },
    {
        timezone: 'Australia/Sydney',
    },
];

const DashboardAvailableTimezonesSetting = (props) => {
    const { dashboardAvailableTimezones, toggleChange } = props;

    const { t } = useTranslation();
    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} mt={2}>
            <FormGroup>
                <InputLabel>{t('settings.dashboardAvailableTimezones.title')}</InputLabel>
                <CustomAutocompleteSearch
                    selectedValues={dashboardAvailableTimezones.map((tz) => ({ timezone: tz }))}
                    setSelectedValues={(value) =>
                        toggleChange(
                            SettingsKey.DASHBOARD_AVAILABLE_TIMEZONES,
                            value.map((tz) => tz.timezone),
                        )
                    }
                    options={TIME_ZONES}
                    keyProp="timezone"
                    optionProp="timezone"
                />
            </FormGroup>
        </Stack>
    );
};

export default DashboardAvailableTimezonesSetting;
